import styled, { css } from 'styled-components';
import { px2rem, opacify } from '../utils/helpers/style.js';
import { styles } from '../constants/styles.js';
import { spacing } from '../constants/spacing.js';
import { fontFamilyStyles } from '../ContentText/styles.web.js';
import { boxStyles } from '../Box/styles.js';
import { lineHeights } from '../constants/line-heights.js';
import { baseButtonStyles } from '../Button/styles.js';
import { boxStyledOptions } from '../utils/helpers/styled.js';

var stepperIndicatorSmall = 40;
var stepperIndicatorLarge = 48;
var wrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__wrapper",
  componentId: "sc-7vqnsx-0"
})(["padding-left:", ";"], function (props) {
  return props.$layout === 'vertical' ? spacing.xl : 0;
});
var stepContent = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__stepContent",
  componentId: "sc-7vqnsx-1"
})(["position:relative;width:", ";left:", ";"], function (props) {
  return props.$width !== undefined ? props.$width : undefined;
}, function (props) {
  return props.$left !== undefined ? props.$left : undefined;
});
var getBorderColor = function getBorderColor(props) {
  if (props.$transparent) {
    var color = props.$valid ? props.theme.stepper.web.connector.transparentColor : opacify(props.theme.stepper.web.connector.transparentColor, props.theme.stepper.web.transparent.inactiveOpacity);
    return color;
  } else {
    return props.$valid ? props.$color : props.theme.stepper.web.connector.inactiveColor;
  }
};
var stepWrapper = /*#__PURE__*/styled.div.withConfig(boxStyledOptions).withConfig({
  displayName: "styles__stepWrapper",
  componentId: "sc-7vqnsx-2"
})(["position:relative;vertical-align:top;display:flex;flex-direction:column;&:before{border-color:", ";border-style:", ";border-width:0;content:'';position:absolute;transition:border ", ";transition-timing-function:", ";}&:last-child{&:before{display:none;}}", " ", " ", ";"], getBorderColor, function (props) {
  return props.$valid ? 'solid' : 'dashed';
}, styles.transition.timing.slower, styles.transition["function"].base, function (props) {
  return props.$layout === 'vertical' && css(["display:block;text-align:left;width:auto;&:before{border-top-width:0;border-left-width:", ";height:calc( 100% - ", " );left:", ";margin-top:", ";top:0;width:0;}"], px2rem(2), px2rem(props.$hasIcon ? stepperIndicatorLarge : stepperIndicatorSmall), px2rem(-45), px2rem(props.$hasIcon ? stepperIndicatorLarge : stepperIndicatorSmall));
}, function (props) {
  return props.$layout === 'horizontal' && css(["display:inline-block;text-align:center;width:", "%;&:before{border-top-width:", ";border-left-width:0;height:0;left:", ";margin-left:", ";top:", ";width:calc( 100% - ", " );}"], 100 / props.$numSteps, px2rem(2), props.$align === 'start' ? '0%' : '50%', px2rem(props.$hasIcon ? stepperIndicatorLarge / 2 : stepperIndicatorSmall / 2), px2rem(stepperIndicatorLarge / 2), px2rem(props.$hasIcon ? stepperIndicatorLarge : stepperIndicatorSmall));
}, boxStyles);
var stepHeader = /*#__PURE__*/styled.p.withConfig({
  displayName: "styles__stepHeader",
  componentId: "sc-7vqnsx-3"
})(["", ";color:", ";line-height:", ";margin:0 0 ", ";padding-top:", ";font-size:", ";font-weight:", ";text-align:inherit;", ""], fontFamilyStyles, function (props) {
  return props.$transparent ? props.theme.stepper.web.header.transparentColor : props.$inactive ? props.theme.stepper.web.header.inactiveColor : props.theme.stepper.web.header.activeColor;
}, function (props) {
  return props.$layout === 'vertical' ? props.$inactive ? px2rem(38) : px2rem(46) : lineHeights.tight;
}, spacing.xxs, px2rem(2), function (props) {
  return props.$layout === 'vertical' ? px2rem(20) : px2rem(16);
}, function (props) {
  return props.$inactive ? styles.fontWeight["default"] : styles.fontWeight.medium;
}, function (props) {
  return props.$layout === 'vertical' && css(["", "{font-size:", ";}", "{font-size:", ";}"], styles.breakpoint.s, px2rem(26), styles.breakpoint.l, px2rem(29));
});
var stepIndicatorWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styles__stepIndicatorWrapper",
  componentId: "sc-7vqnsx-4"
})(["height:", ";width:100%;display:flex;flex-direction:column;justify-content:center;align-items:", ";"], function (props) {
  return props.$layout === 'horizontal' ? px2rem(stepperIndicatorLarge) : 0;
}, function (props) {
  return props.$align;
});
var extractColor = function extractColor(props, colorKey) {
  if (props.$transparent) {
    if (colorKey === 'backgroundColor') {
      return !props.$inactive && !props.$valid ? props.theme.stepper.web.step.transparent.textColor : 'transparent';
    }
    if (colorKey === 'borderColor') {
      return props.$inactive && !props.$valid ? opacify(props.theme.stepper.web.step.transparent.borderColor, props.theme.stepper.web.transparent.inactiveOpacity) : props.theme.stepper.web.step.transparent.borderColor;
    }
    if (colorKey === 'textColor') {
      return !props.$inactive ? props.$color : props.theme.stepper.web.step.transparent.textColor;
    }
  }
  if (props.$valid) {
    return colorKey == 'borderColor' ? props.$color : props.theme.stepper.web.step.valid[colorKey];
  }
  if (props.$inactive) {
    return props.theme.stepper.web.step.invalid[colorKey];
  }
  return colorKey === 'backgroundColor' || colorKey == 'borderColor' ? props.$color : props.theme.stepper.web.step.active[colorKey];
};
var getIndicatorSize = function getIndicatorSize(props) {
  if (!props.$inactive && !props.$valid || props.$hasIcon) {
    return px2rem(stepperIndicatorLarge);
  }
  return px2rem(stepperIndicatorSmall);
};
var stepIndicator = /*#__PURE__*/styled.button.withConfig({
  displayName: "styles__stepIndicator",
  componentId: "sc-7vqnsx-5"
})(["", ";", " box-sizing:border-box;background:", ";border-radius:50%;border:", " solid ", ";color:", ";display:inline-flex;align-items:center;justify-content:center;font-size:", ";font-weight:", ";height:", ";width:", ";letter-spacing:0;position:relative;text-align:center;transition:color ", ",background ", ",border ", ";transition-timing-function:", ";", ""], fontFamilyStyles, function (p) {
  return p.onClick ? baseButtonStyles : undefined;
}, function (props) {
  return extractColor(props, 'backgroundColor');
}, px2rem(2), function (props) {
  return extractColor(props, 'borderColor');
}, function (props) {
  return extractColor(props, 'textColor');
}, px2rem(18), styles.fontWeight.medium, function (p) {
  return getIndicatorSize(p);
}, function (p) {
  return getIndicatorSize(p);
}, styles.transition.timing.slower, styles.transition.timing.slower, styles.transition.timing.slower, styles.transition["function"].base, function (props) {
  return props.$layout === 'vertical' && css(["left:", ";position:absolute;top:0;"], !props.$inactive && !props.$valid || props.$hasIcon ? px2rem(-68) : px2rem(-64));
});

export { stepContent, stepHeader, stepIndicator, stepIndicatorWrapper, stepWrapper, wrapper };
